import { IFedNowDetails } from '../../interfaces/fednow-details.interface';
import { IRtpDetails } from '../../interfaces/rtp-details.interface';

export abstract class AbstractDashboardDetailsService {
  abstract getFedNowDetails(): Promise<IFedNowDetails | undefined>;
  abstract getRtpDetails(): Promise<IRtpDetails | undefined>;
}
